import { createApp } from "vue";
import App from "./App.vue";
// reset style sheet
import "@/styles/index.css";
import "@/styles/index.scss";

import "vant/es/toast/style";
import "vant/es/dialog/style";
import "vant/es/notify/style";
import "vant/es/image-preview/style";
import VueLuckyCanvas from "@lucky-canvas/vue";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
// 引入模块后自动生效
import "@vant/touch-emulator";

import i18n from "@/language";

// vue Router
import router from "@/routers";
// pinia store
import pinia from "@/stores";
// errorHandler
import errorHandler from "@/utils/errorHandler";

const app = createApp(App);

app.config.errorHandler = errorHandler;
app
	.use(router)
	.use(pinia)
	.use(i18n)
	.use(VueLuckyCanvas)
	.use(VueTelInput as any)
	.mount("#app");
